export const iconFontAwesomeMaritimeSailboat = (
	<i className="fa-solid fa-sailboat"></i>
);
